import React from "react";
import { PatientTaskInstanceId } from "../../messages/ObjectIds";
import { PatientTaskBroadcastDetails } from "../../messages/PatientTasks";
import { AppCaregiver } from "../../system/AppState/AppCaregiverState";
import { AppCard, AppCardContent } from "../Generic/AppCard";
import Flex from "../Generic/Flex";
import PatientAvatar from "../PatientAvatar/PatientAvatar";
import AvailableTaskListItemAddressEngagement from "./components/AvailableTaskListItemAddressEngagement";
import AvailableTaskListItemDetails from "./components/AvailableTaskListItemDetails";
import AvailableTaskListItemTitle from "./components/AvailableTaskListItemTitle";

interface AvailableVisitListItemProps {
  task: PatientTaskBroadcastDetails;
  handleAvailableTaskClick: (taskBroadcastId: PatientTaskInstanceId) => void;
  caregiver: AppCaregiver;
  index: number;
}

const AvailableTaskListItem = (props: AvailableVisitListItemProps) => {
  return (
    <AppCard
      className="AvailableTasksListItem"
      color="primary"
      variant="soft"
      style={{ animationDelay: `${Math.min(props.index * 50, 400)}ms` }}
      onClick={() => props.handleAvailableTaskClick(props.task.taskInstanceId)}
    >
      <AppCardContent>
        <Flex direction="row" xGap={16} alignItems="center">
          <PatientAvatar initials={props.task.patientInitials} />

          <Flex direction="column" yGap={10} flex={1}>
            <AvailableTaskListItemTitle
              title={props.task.title}
              certifications={props.task.certifications}
            />
            <AvailableTaskListItemDetails
              startDate={props.task.startDate}
              dueDate={props.task.dueDate}
              durationMinutes={props.task.durationMinutes}
            />
            <AvailableTaskListItemAddressEngagement
              addressComponents={props.task.patientAddressComponents}
              viewedAt={props.task.viewedAt}
            />
          </Flex>
        </Flex>
      </AppCardContent>
    </AppCard>
  );
};

export default AvailableTaskListItem;
